// extracted by mini-css-extract-plugin
export default {"backgroundImage":"JP","content":"KP","rtbLeft":"LP","rtbRight":"MP","rtbLeftMobile":"NP","imageContainer":"OP","rtbBox":"PP","line":"QP","rtbDesktop":"RP"};
    if(module.hot) {
      // 1737143662642
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  